/* unplugin-vue-components disabled */import { render } from "./analytics.vue?vue&type=template&id=43080b56&scoped=true"
import script from "./analytics.vue?vue&type=script&setup=true&lang=js"
export * from "./analytics.vue?vue&type=script&setup=true&lang=js"

import "./analytics.vue?vue&type=style&index=0&id=43080b56&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43080b56"],['__file',"src/pages/settings/analytics/analytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43080b56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43080b56', __exports__)) {
    api.reload('43080b56', __exports__)
  }
  
  module.hot.accept("./analytics.vue?vue&type=template&id=43080b56&scoped=true", () => {
    api.rerender('43080b56', render)
  })

}


export default __exports__